import type { Field, Item } from './infra';

export const MACRO_MAX_FILE_BYTES = 1024 * 1024;
export const MACRO_MAX_TOTAL_BYTES = 2 * 1024 * 1024;
const RESERVED = new Set(['input.json', 'result.json', 'script.sh', 'stdout.log', 'stderr.log', 'cleanup.json']);

export function macroAttachmentError(files: Item[]): string {
  if (files.length > 20) return '첨부파일은 최대 20개입니다.';
  const names = new Set<string>();
  for (const file of files) {
    if (!/^[a-zA-Z0-9][a-zA-Z0-9_.-]{0,119}$/.test(file['name']) || file['name'].includes('..') || RESERVED.has(file['name']))
      return '첨부 이름은 영문·숫자로 시작하는 단일 파일명이어야 하며 예약된 이름은 사용할 수 없습니다.';
    if (names.has(file['name'])) return '첨부파일 이름이 중복되었습니다.';
    names.add(file['name']);
    if (file['size'] > MACRO_MAX_FILE_BYTES) return '첨부파일은 각각 1MB 이하여야 합니다.';
  }
  return files.reduce((sum, file) => sum + Number(file['size']), 0) > MACRO_MAX_TOTAL_BYTES
    ? '첨부파일은 전체 2MB 이하여야 합니다.' : '';
}

export function macroRunFields(servers: Item[], services: Item[], containers: Item[], form: Item, loading: boolean): Field[] {
  const selected = services.filter(service => service['serverId'] === form['serverId']);
  const choices = containers.filter(container => container['state'] === 'running'
    && (!form['serviceId'] || container['serviceId'] === form['serviceId']));
  return [
    { key: 'serverId', label: '실행할 서버', type: 'select', required: true,
      options: servers.filter(server => server['eligible'] !== false).map(server => ({ value: server['id'], label: server['name'] })) },
    { key: 'serviceId', label: '서비스 (선택)', type: 'select', disabled: !form['serverId'] || loading,
      placeholder: '서비스 선택 없이 실행', options: selected.map(service => ({ value: service['id'], label: service['name'] })) },
    { key: 'containerId', label: '컨테이너 (선택)', type: 'select', required: !!form['serviceId'], disabled: !form['serverId'] || loading,
      placeholder: loading ? '컨테이너 불러오는 중…' : '서버에서 직접 실행',
      options: choices.map(container => ({ value: container['id'], label: container['name'] + ' · ' + container['id'].slice(0, 12) })),
      hint: '실행 중인 컨테이너만 표시합니다. 선택하지 않으면 서버에서 실행합니다.' },
    { key: 'args', label: '인자 (한 줄에 하나)', type: 'textarea', rows: 4 },
  ];
}

export function macroRunPayload(form: Item): Item {
  return { serverId: form['serverId'], serviceId: form['serviceId'] || null, containerId: form['containerId'] || null,
    args: String(form['args'] ?? '').split(/\r?\n/).filter(value => value !== '') };
}

export function macroAgentDraft(result: Item): { script: string; summary: string } {
  if (typeof result['script'] !== 'string' || !result['script'].trim()
    || result['script'].length > 65536 || result['script'].includes('\0'))
    throw new Error('Agent 응답에 유효한 Shell 스크립트가 없습니다.');
  return { script: result['script'], summary: String(result['summary'] || '스크립트 초안을 작성했습니다.') };
}
